export enum ColumnTypes {
    EVENT_SOURCE = 'source',
    EVENT_TYPE = 'type',
    EVENT_FAMILIES = 'families',
    EVENT_CODE = 'code',
    EVENT_DESCRIPTION = 'description',
    EVENT_ATTRIBUTES = 'attributes',
    EVENT_FIRST_USAGE_DATE = 'firstUsageDate',
    EVENT_LAST_USAGE_DATE = 'lastUsageDate',
}

export const COLUMN_CAPTIONS = {
    [ColumnTypes.EVENT_SOURCE]: 'Event Source',
    [ColumnTypes.EVENT_FAMILIES]: 'Families',
    [ColumnTypes.EVENT_CODE]: 'Event Code',
    [ColumnTypes.EVENT_TYPE]: 'Event Type',
    [ColumnTypes.EVENT_DESCRIPTION]: 'Event Description',
    [ColumnTypes.EVENT_ATTRIBUTES]: 'Attributes',
    [ColumnTypes.EVENT_FIRST_USAGE_DATE]: 'First Usage',
    [ColumnTypes.EVENT_LAST_USAGE_DATE]: 'Last Usage',
};

export const ColumnWidth = {
    [ColumnTypes.EVENT_SOURCE]: '11rem',
    [ColumnTypes.EVENT_FAMILIES]: '9rem',
    [ColumnTypes.EVENT_TYPE]: '11rem',
    [ColumnTypes.EVENT_CODE]: '10%',
    [ColumnTypes.EVENT_DESCRIPTION]: 'calc(68% - 65.5rem)',
    [ColumnTypes.EVENT_ATTRIBUTES]: '24rem',
    [ColumnTypes.EVENT_FIRST_USAGE_DATE]: '9rem',
    [ColumnTypes.EVENT_LAST_USAGE_DATE]: '9.5rem',
};
